import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	aiNote: {
		id: 'servicedesk-itsm-features.common.ai-footer.ai-note',
		defaultMessage: 'Powered by Atlassian Intelligence',
		description:
			'Label shown in the footer of bulk move issue modal when Atlassian Intelligence is triaging',
	},
	contentQualityStatement: {
		id: 'servicedesk-itsm-features.common.ai-footer.content-quality-statement',
		defaultMessage: 'Content is based on your permissions, and its quality may vary',
		description:
			'Label shown in the footer of bulk move issue modal to indecate Atlassian Intelligence generated content quality may vary',
	},
	betaAccessLozenge: {
		id: 'servicedesk-itsm-features.common.ai-footer.beta-access-lozenge',
		defaultMessage: 'Beta',
		description:
			'Small lozenge that appears to the right of the board title, indicating a beta feature.',
	},
});
